import { Box, Button, Checkbox, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { StyledMainTableCell, StyledMainTableRow } from "../../../components/TableComponent";
import { useEffect, useState } from "react";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import dayjs from "dayjs";

const TableCustomRow = ({ item, isItemSelected, selectRowEvent, makeReceivedNew }) => {
    const [open, setOpen] = useState(false);
    const [remainingItemIds, setRemainingItemIds] = useState([]);

    useEffect(() => {
        let remainingItemIdsTemp = item?.products?.map(i => {
            if (i?.is_wh_received === 0)
                return i?.id;
            return null;
        });

        remainingItemIdsTemp = remainingItemIdsTemp?.filter(i => i !== null);

        setRemainingItemIds(remainingItemIdsTemp);
    }, [item]);

    return <>
        <StyledMainTableRow sx={{ "& > *": { borderBottom: "unset" } }} onClick={(e) => selectRowEvent(item?.id)} aria-checked={isItemSelected} selected={isItemSelected}>
            <TableCell padding="checkbox">
                <Checkbox color="primary" checked={isItemSelected} />
            </TableCell>
            <TableCell>
                <IconButton aria-label="expand row" size="small" onClick={(e) => { e.stopPropagation(); setOpen(!open); }}>{open ? (<KeyboardArrowUp />) : (<KeyboardArrowDown />)}</IconButton>
                {item?.booking_id}
            </TableCell>
            <TableCell component="th" scope="row">{item?.customer_name}</TableCell>
            <TableCell component="th" scope="row">{item?.pickup_details?.address}</TableCell>
            <TableCell component="th" scope="row">{dayjs(item?.pickup_date).format("DD/MM/YYYY")}</TableCell>
            <TableCell component="th" scope="row">
                <Button className="TableAddBU" onClick={(e) => { makeReceivedNew(remainingItemIds); }}>RECEIVE ALL</Button>
            </TableCell>
        </StyledMainTableRow>
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                        <Table size="small" aria-label="purchases">
                            <TableHead>
                                <TableRow>
                                    <StyledMainTableCell>ITEM ID</StyledMainTableCell>
                                    <StyledMainTableCell align="left">ITEM</StyledMainTableCell>
                                    <StyledMainTableCell align="left"></StyledMainTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {item?.products.map((row) => (<TableRow key={row?.id}>
                                    <TableCell component="th" scope="row">{row?.item_id}</TableCell>
                                    <TableCell>{row?.product_title}</TableCell>
                                    <TableCell align="right">
                                        {row?.is_wh_received === 0 ? (<Button className="CancelBU" onClick={(e) => { makeReceivedNew([row?.id]); }}>Receive</Button>) : ("")}
                                    </TableCell>
                                </TableRow>))}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    </>
}

export default TableCustomRow;